import { render, staticRenderFns } from "./ConsentCreate.vue?vue&type=template&id=6691d354&scoped=true&"
import script from "./ConsentCreate.vue?vue&type=script&lang=js&"
export * from "./ConsentCreate.vue?vue&type=script&lang=js&"
import style0 from "./ConsentCreate.vue?vue&type=style&index=0&id=6691d354&prod&lang=css&"
import style1 from "./ConsentCreate.vue?vue&type=style&index=1&id=6691d354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6691d354",
  null
  
)

export default component.exports